import React from "react"
import FieldProto from "../proto/field-proto";

export type FieldViewPropertyProps = {
    field       : FieldProto;
    model       : any;
    className?  : string;
    style?      : any
    // options?    : any
    onClick?    : onClick
    // viewType?   : string        // specify how to render view for advanced cases i.e. project as full path or name as property

    params?     : any           // some special parameters (like 'availableWidth' for charts)

    // children?   : any
}

export default function FieldViewProperty(props:FieldViewPropertyProps):React.ReactElement {

    // console.log("FIELDVIEW ", props)

    return <props.field.renderComponents.viewProperty {...props} />

}